export default __webpack_public_path__ + "static/media/popularService(4).5456a2c7.png";